module.exports = __webpack_public_path__ + "img/Syntax.19825e71.jpg";